// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { TelemetryEventNames, dispatchTelemetryEvent } from "../../Social.telemetry";

export interface ProfileReportMenuTelemetryObjects {
    reportUserMenuTypes: TelemetryObjectBase;
}

export const profileReportMenuTelemetryContracts = {
    /** Scenario 4 Impr update of report user reason*/
    reportUserMenuTypes: {
        name: "ReportUserReason",
        content: {
            type: TelemetryContentType.Profile
        }
    }
};

export const profileReportMenuTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    reportTypeClicked: (element: any, telemetryObject: any): void => {
        const telemetryEventDispatcherInfo = {
            eventName: TelemetryEventNames.genericAction,
            contract: {...(telemetryObject && telemetryObject.contract)},
            subTypes: { behavior: TelemetryBehaviorType.Report }
        };

        dispatchTelemetryEvent(telemetryEventDispatcherInfo, element);
    }
};